import link from "@/scripts/host.js";

export default {
  name: 'songInfo',
  data() {
    return {
      song: null,
      songPositions: null,
      songsList: null,
      artistPhoto: null,
      resultsInfo: [],
    }
  },
  computed: {
    paramethers() {
      return this.$route.path;
    },

  },
  methods: {
    goToSong(id) {
      if(!this.$route.path.includes(`/utwór/${id}`)){
        this.$router.push(`/utwór/${id}`)
      }
    },
    goToArtistSite(id) {
      if(!this.$route.path.includes(`/artysta/${id}`)){
        this.$router.push(`/artysta/${id}`)
      }
    },
    goToList(id) {
      if(!this.$route.path.includes(`/lp3/${id}`)){
        this.$router.push(`/lp3/${id}`)
      }
    },
    async getInfo() {
      const songId = this.$route.params.id;
      await this.axios.get(`${link.hostLink}Song/GetInfo?id=${songId}`).then((response) => {
        this.song = response.data;
        this.resultsInfo = response.data.resultsInfo
      })
      await this.axios.get(`${link.hostLink}Artist/GetSongs?id=${this.song.artists[0].id}`).then((response)=>{
        this.songsList = response.data;
      })

      await this.axios.get(`${link.hostLink}Artist/GetDetails?id=${this.song.artists[0].id}`).then((response)=>{
        this.artistPhoto = response.data.photo;
      })
      
    },
   
    showInfoIfNotOnList(value){
      if(value) {
        return 'data debiutu na liście'
      } else {
        return 'Utwór nie był notowany'
      }
    },
    songIsActive(songId) {
      return String(songId) === String(this.$route.params.id);
    }
  },
  mounted() {
    this.getInfo();
  },
  watch: {
    paramethers() {
      this.getInfo();
    },
   
  }
}
